























































import Vue, { PropType } from 'vue';
// import { ItemData } from '@/modules/exhibitor/item';
import {
  Item,
} from 'mostra';

export default Vue.extend({
  name: 'GItemImageForm',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    item: {
      type: Object as PropType<Item>,
      required: true,
    },
  },
});
